import { ShelfSet } from '@/Engine/Wardrobe/ShelfSet';
import { wardrobeTemplates } from '@/Interfaces/common';
import { useUIOnlyStore } from '@/Store/storeUI';
import { $ } from '@/Engine/state';
import { useStoreData } from '@/Store/storeData';
import { convertItem } from '@/lib/createModule';
import { useConfigurationStore } from '@/Store/storeConfiguration';

export const getShelfAccessories = (name: string) => {
    const shelfSet = $.selectionBox?.target as ShelfSet;
    if (!shelfSet) {
        return null;
    }

    return useStoreData().items
        .filter((item) => item.name.includes(name))
        .filter((item) => shelfSet.color.includes(item.color.hex))
        .filter((item) => item.compatibilityDepth === shelfSet.compatibilityDepth);
};

export const addShelfAccessories = (side: 'left' | 'right', name: string) => {

    const shelfSet = $.selectionBox?.target as ShelfSet;
    if (!shelfSet) {
        return;
    }
    const newTemplate = JSON.parse(JSON.stringify(shelfSet.templates)) as wardrobeTemplates;

    const shelfAccessories = getShelfAccessories(name);

    if (!shelfAccessories[0]) {
        console.warn('Не найден подходящая боковая панель с крючками');
        console.warn(shelfSet.compatibilityDepth, shelfSet.color);
        return;
    }

    const extraItemTemplate = convertItem(shelfAccessories[0]);

    if (side === 'left') {
        if (newTemplate.bracketLeftExtra && newTemplate.bracketLeftExtra.name === extraItemTemplate.name) {
            newTemplate.bracketLeftExtra = undefined;
        } else {
            newTemplate.bracketLeftExtra = extraItemTemplate;
        }
    }

    if (side === 'right') {
        if (newTemplate.bracketRightExtra && newTemplate.bracketRightExtra.name === extraItemTemplate.name) {
            newTemplate.bracketRightExtra = undefined;
        } else {
            newTemplate.bracketRightExtra = extraItemTemplate;
        }
    }

    shelfSet.templates = newTemplate;
    shelfSet.updateModels(newTemplate);
    shelfSet.updatePartPosition();
    $.render();
    useConfigurationStore().addKit($.wardrobe.raw);
};
